module.exports = __webpack_public_path__ + "static/media/murderballadizer-demo.1b5cb7cb.mp4";